import withAuth from "./withAuth";

export interface withAuthProps {
  currentAuthStatus: string;
}

export default withAuth;
